<template>
  <div
    ref="kt_modal_exibir_ajuda"
    data-bs-backdrop="static"
    data-bs-focus="false"
    :class="[modal == true ? 'modal fade modal-overlay' : 'card shadow']"
    tabindex="-1"
    id="kt_modal_exibir_ajuda"
    data-bs-keyboard="false"
  >
    <div
      :class="[
        modal == true
          ? 'modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable'
          : '',
      ]"
    >
      <div class="modal-content">
        <div v-if="modal == true" class="modal-header">
          <div class="modal-title d-flex align-items-center">
            <div
              v-if="ajuda.imagem ? ajuda.imagem : ''"
              class="symbol symbol-50px"
            >
              <div
                class="symbol-label fs-2 fw-bold bg-light-dark"
                :style="{
                  'background-image': `url(${
                    this.$utils.getUrl() + ajuda.imagem
                  })`,
                }"
              ></div>
            </div>
            <div v-else class="symbol symbol-50px">
              <div :class="['symbol-label fs-2 fw-bold ' + ajuda.color]">
                {{
                  ajuda.descricao
                    ? ajuda.descricao.substring(0, 1).toUpperCase()
                    : ""
                }}
              </div>
            </div>
            <h3 class="ms-6 fw-bold m-0 text-gray-800">
              Ajuda - {{ ajuda ? ajuda.descricao : "" }}
            </h3>
          </div>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            data-bs-dismiss="modal"
            @click="this.$emit('cancelarExibirAjuda', false)"
          >
            <span class="svg-icon svg-icon-1 svg-icon lh-0">
              <inline-svg src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body">
          <div class="p-2 bg-light">
            <div class="d-flex flex-wrap gap-1">
              <button
                type="button"
                class="btn btn-sm btn-active-secondary"
                @click="this.imprimir()"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Imprimir"
              >
                <div class="d-flex flex-wrap">
                  <i class="fas fa-print fs-4 p-0"></i>
                </div>
              </button>
              <button
                type="button"
                class="btn btn-sm btn-active-secondary"
                @click="this.enviarEmail()"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Enviar por e-mail"
              >
                <div class="d-flex flex-wrap">
                  <i class="fas fa-envelope fs-4 p-0"></i>
                </div>
              </button>
              <button
                type="button"
                class="btn btn-sm btn-active-secondary"
                @click="this.download()"
                data-bs-toggle="tooltip"
                data-bs-placement="top"
                title="Download"
              >
                <div class="d-flex flex-wrap">
                  <i class="fas fa-download fs-4 p-0"></i>
                </div>
              </button>
            </div>
          </div>
          <div
            :id="`htmlConteudo${this.ajudaGuid}`"
            class="ck-content p-5"
            v-html="ajuda ? ajuda.conteudo : ''"
          ></div>
        </div>
      </div>
    </div>
  </div>
  <SendMailModal
    v-if="exibirModalEmail"
    :show="exibirModalEmail"
    :emails="emails"
    :assunto="assuntoEmail"
    :mensagem="mensagemEmail"
    :anexos="anexosEmail"
    @exibirModalMail="exibirModalMail"
  ></SendMailModal>
  <LoadingModal
    :nomeRef="'loadingModalAjuda'"
    mensagem=""
    v-if="this.loading === true"
  ></LoadingModal>
</template>

<script>
import html2pdf from "html2pdf.js";
import SendMailModal from "@/components/modals/general/SendMailModal";
import {
  hideModal,
  getOrCreateInstanceModal,
  hideModalId,
} from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import LoadingModal from "@/components/modals/general/LoadingModal.vue";

export default {
  emits: ["cancelarExibirAjuda"],
  components: {
    SendMailModal,
    LoadingModal,
  },
  props: {
    ajuda: { type: Object, required: true },
    modal: { type: Boolean, required: false, default: true },
  },
  methods: {
    async exibirModalLoading(exibir, callback) {
      if (exibir === true) {
        this.loading = true;
        getOrCreateInstanceModal(
          "loadingModalAjuda",
          /*open*/ null,
          /*close*/ null
        );
      } else {
        hideModalId("loadingModalAjuda", () => {
          this.loading = false;
          this.$nextTick(() => {
            if (callback) {
              callback();
            }
          });
        });
      }
    },
    async imprimir() {
      await this.exibirModalLoading(true);
      const el = document.getElementById(`htmlConteudo${this.ajudaGuid}`);

      await html2pdf()
        .set(this.pdfOptions)
        .from(el)
        .outputPdf("bloburl", this.ajudaGuid)
        .then(function (pdf) {
          const newWindow = window.open(pdf, "_blank");

          if (newWindow) {
            newWindow.addEventListener("load", function () {
              newWindow.print();
            });
          }
        });
      await this.exibirModalLoading(false);
    },
    async enviarEmail() {
      await this.exibirModalLoading(true);
      const el = document.getElementById(`htmlConteudo${this.ajudaGuid}`);

      var pdfBlob = await html2pdf()
        .set(this.pdfOptions)
        .from(el)
        .outputPdf("blob", this.ajudaGuid)
        .then(async function (pdf) {
          return pdf;
        });

      let pdfBase64 = [];
      await this.$utils.blobToBase64(pdfBlob).then((res) => {
        pdfBase64 = res;
      });

      this.emails = [];
      this.assuntoEmail = this.ajuda.descricao
        ? this.ajuda.descricao
        : this.ajuda.label;
      this.mensagemEmail = "";
      this.anexosEmail = [
        { nome: this.ajudaGuid + ".pdf", base64Arquivo: pdfBase64 },
      ];
      await this.exibirModalLoading(false);
      this.exibirModalMail(true);
    },
    async exibirModalMail(exibir) {
      this.exibirModalEmail = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_send_mail",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_send_mail");
          },
          /*close*/ () => {
            this.exibirModalMail(false);
          }
        );
      }
    },
    async download() {
      await this.exibirModalLoading(true);
      const el = document.getElementById(`htmlConteudo${this.ajudaGuid}`);
      await html2pdf().set(this.pdfOptions).from(el).save(this.ajudaGuid);
      await this.exibirModalLoading(false);
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
  },
  async mounted() {
    this.ajudaGuid = this.$utils.generateUuidv4();
  },
  data() {
    return {
      loading: false,
      timeOut: null,
      ajudaGuid: "",
      exibirModalEmail: false,
      emails: [],
      assuntoEmail: "",
      mensagemEmail: "",
      anexosEmail: [],
      pdfOptions: {
        margin: 10,
        image: {
          type: "jpeg",
          quality: 1,
        },
        html2canvas: { scale: 3, useCORS: true },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "p",
        },
      },
    };
  },
};
</script>

<style>
code {
  font-size: inherit !important;
  color: var(--kt-code-color) !important;
  text-shadow: none !important;
  font-family: var(--bs-font-monospace) !important;
}
@import "../../assets/css/content-styles.css";
</style>
